import React, {Component} from 'react';
import '../css/ContactForm.css';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import TextInput from './TextInput';
import Button from './Button';
import {
  COLORS,
  orgEmail,
  orgPhone,
  orgPhoneFormatted,
} from '../constants';
import {getLang} from '../selectors';
import {ContactForm as cfs} from '../strings';



class ContactForm extends Component {

  static defaultProps = {
    shouldRenderInfo: true,
    shouldRenderForm: false,
    showTitle: true,
    light: false,
  }

  state = {
    formValues: {
      name: '',
      phone: '',
      email: '',
      message: '',
    },
  }

  handleInputChange = (field, event) => {
    this.setState({
      formValues: {
        ...this.state.formValues,
        [field]: event.target.value,
      }
    })
  }

  renderInfo() {
    const {light} = this.props;
    const styles = {
      email: {
        ...s.email,
        ...(light ? {color: COLORS.lightBlack} : {}),
      },
      phone: {
        ...s.phone,
        ...(light ? {color: COLORS.lightBlack} : {}),
      },
    }
    return (
      <div>
        <div style={styles.email} className='link'>
          {orgEmail}
        </div>
        {/* <a style={styles.email} href={`mailto:${orgEmail}`} target='_blank' rel='noopener noreferrer' className='link'>
          {orgEmail}
        </a> */}
        {/* <a style={styles.phone} href={`tel:${orgPhone}`} className='link'>
          {orgPhoneFormatted}
        </a> */}
      </div>
    )
  }

  renderForm() {
    return (
      <div>

        <div style={s.field}>
          <TextInput
            label="Name"
            onChange={(e) => this.handleInputChange('name', e)}
          />
        </div>

        <div style={s.field}>
          <TextInput
            label="Email"
            onChange={(e) => this.handleInputChange('email', e)}
          />
        </div>

        <div style={s.field}>
          <TextInput
            label="Phone"
            onChange={(e) => this.handleInputChange('phone', e)}
          />
        </div>

        <div style={s.field}>
          <TextInput
            label="Message"
            isTextArea={true}
            textAreaRows={4}
            onChange={(e) => this.handleInputChange('message', e)}
          />
        </div>

        <div style={s.buttonContainer}>
          <Button
            label="Submit"
            onClick={this.handleSubmit}
          />
        </div>

      </div>
    )
  }

  render() {
    const {
      lang,
      shouldRenderInfo,
      shouldRenderForm,
      showTitle,
    } = this.props;

    return(
      <div style={s.container} className='contact-form'>

        {showTitle &&
          <div style={s.header}>
            <div style={s.title}>
              {cfs.contactUs[lang]}
            </div>
          </div>
        }

        {shouldRenderInfo &&
          <div style={s.infoContainer}>
            {this.renderInfo()}
          </div>
        }

        {shouldRenderForm &&
          <div style={s.formContainer}>
            {this.renderForm()}
          </div>
        }
      </div>
    )
  }
}


const s = {
  container: {

  },
  header: {

  },
  title: {
    fontSize: '100%',
    //fontWeight: 'bold',
    //fontStyle: 'italic',
    color: COLORS.gray200,
    marginBottom: '10px',
  },
  formContainer: {

  },
  field: {
    marginBottom: '20px',
  },
  buttonContainer: {
    marginTop: '10px',
  },
  infoContainer: {

  },
  email: {
    color: COLORS.gray200,
    marginBottom: '10px',
    fontSize: '90%',
  },
  phone: {
    color: COLORS.gray200,
    fontSize: '90%',
  },
}

const mapStateToProps = (state, ownProps) => {
  return {
    lang: getLang(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

  }
}


const Connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactForm)

export default withRouter(Connected);



// WEBPACK FOOTER //
// ./src/main/ContactForm.js